import { Link, TableCell, TableRow } from '@ksyos/design-system';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import type { IEmploymentCarePaths } from './PersonalSettingsCarePathsOverview';
import { translateKey } from '../../../../translate';

interface IPersonalSettingsCarePathOverviewDetailsInactiveServiceGroupInActiveCarePathBlockProps {
    carePathName: string;
    carePaths: IEmploymentCarePaths;
    inactiveServiceGroupBlock: JSX.Element[];
    isActiveCarePath: boolean;
}

export function PersonalSettingsCarePathOverviewDetailsInactiveServiceGroupInActiveCarePathBlock(
    props: IPersonalSettingsCarePathOverviewDetailsInactiveServiceGroupInActiveCarePathBlockProps
) {
    const [showInactiveServiceGroup, setShowInactiveServiceGroup] = useState<{ [serviceGroup: string]: boolean }>({});

    if (!props.isActiveCarePath || isEmpty(props.carePaths[props.carePathName]['inactive'])) {
        return null;
    }

    const amountOfInactiveServiceGroups = Object.keys(props.carePaths[props.carePathName]['inactive']).length;

    return (
        <>
            {showInactiveServiceGroup[props.carePathName] && props.inactiveServiceGroupBlock}
            <TableRow key={`${props.carePathName}-${amountOfInactiveServiceGroups}-link`}>
                <TableCell colSpan={5}>
                    <Link
                        onClick={(e) => {
                            e.preventDefault();
                            setShowInactiveServiceGroup({
                                [props.carePathName]: !showInactiveServiceGroup[props.carePathName],
                            });
                        }}
                        variant="button"
                    >
                        {showInactiveServiceGroup[props.carePathName]
                            ? translateKey('episodeCategory.hideInactiveServiceGroups')
                            : showInactiveServiceGroupsText(amountOfInactiveServiceGroups)}
                    </Link>
                </TableCell>
            </TableRow>
        </>
    );
}

function showInactiveServiceGroupsText(amountOfInactiveServiceGroups: number) {
    return amountOfInactiveServiceGroups === 1
        ? translateKey('episodeCategory.showInactiveServiceGroup')
        : translateKey('episodeCategory.showInactiveServiceGroups', `${amountOfInactiveServiceGroups}`);
}
